import { VOInfo } from "../model/DataStructure.js";
import { Polygon } from "./Polygon.js";

export interface HelpOptions {
    container: HTMLElement;
    hidden?: boolean;
    info?: VOInfo
}

interface HelpBlock {
    image?: string;
    inlineSvg?: boolean;
    title?: string;
    text?: string;
}

export class Help {
    private _element: HTMLDivElement;

    constructor(options: HelpOptions) {
        options = e5.object.merge({
            hidden: true,
        } as HelpOptions, options);

        this._element = document.createElement("div");
        this._element.className = "help";
        if (options.hidden) {
            this._element.classList.add("help--hidden");
        }
        this._element.innerHTML = `
        <div class="help__background"></div>
        <div class="help__box">
            <div class="help__header">    
                <button class="help__button help__button--close e5 icon-592"></button>
            </div>
            <div class="help__body">
                <div class="help__content"></div>
            </div>            
        </div>
        `;

        new Polygon({
            container: this._element.querySelector(".help__box"),
            prepend: true,
            shape: "12"
        });


        if(options.info){
            this.add(options.info);
        }

        e5.event.on({
            type: "click",
            selector: ".help__button--close, .help__background",
            scope: this._element,
            listener: (e) => {
                this.visible = false;
            }
        });

        if (options.container) {
            options.container.appendChild(this._element);
        }
    }

    public get visible(): boolean {
        return !this._element.classList.contains("help--hidden");
    }

    public set visible(value: boolean) {
        if (this.visible === value) {
            return;
        }
        this._element.classList.toggle("help--hidden", !value);
    }

    public add(info: VOInfo): void {
        if (info.name) {
            const c = this._element.querySelector(".help__content");
            const ti = document.createElement("h1");
            ti.className = "help__title";
            ti.textContent = info.name;
            c.appendChild(ti);
        }

        for (let item of info.items) {
            const block: HelpBlock = {};
            if (item.image) {
                block.image = item.image.url;
            }
            if (item.title) {
                block.title = item.title;
            }
            if (item.text) {
                block.text = item.text;
            }
            this.addBlock(block);
        }
    }

    private addBlock(block: HelpBlock): void {

        const e = document.createElement("div");
        e.className = "help__block";

        if (block.image) {
            if (block.inlineSvg) {
                e5.load("svg", block.image).promise.then((svg) => {
                    svg.classList.add("help__block-image");
                    e.prepend(svg);
                });
            } else {
                const image = document.createElement("img");
                image.src = block.image;
                image.className = "help__block-image";
                e.appendChild(image);
            }
        }

        if (block.title) {
            const title = document.createElement("h2");
            title.className = "help__block-title";
            title.textContent = block.title;
            e.appendChild(title);
        }

        if (block.text) {
            const text = document.createElement("p");
            text.className = "help__block-text";
            text.textContent = block.text;
            e.appendChild(text);
        }

        this._element.querySelector(".help__content")
            .appendChild(e);
    }
}